document.addEventListener('alpine:init', () => {
  Alpine.data('fastTabs', () => ({
    tabs: [],
    contents: [],
    slider: null,

    get activeTab() {
      return this._activeTab;
    },
    set activeTab(index) {
      this._activeTab = index;

      this.contents.forEach((content, i) => {
        content.style.display = i === index ? null : 'none';
      });

      window.dispatchEvent(new CustomEvent('fast-tabs'));
    },
    _activeTab: 0,

    init() {
      this.$nextTick(() => this.ready());
    },

    ready() {
      if (this.$root.parentElement) {
        const fastTabs = [...this.$root.parentElement.querySelectorAll('.fast-tabs')];
        const children = [...this.$root.parentElement.children];

        if (fastTabs[0] === this.$root) {
          this.slider = document.createElement('div');
          // this.$root.parentElement.append(this.slider);

          fastTabs.forEach((fastTab, i) => {
            this.tabs.push(fastTab.querySelector('.container').dataset.label);

            const content = document.createElement('div');

            content.dataset.index = i;
            content.classList.add('block__inner-blocks');

            let found = false;

            for (const child of children) {
              if (child === fastTab) {
                found = true;
              } else if (found && child.classList.contains('fast-tabs')) {
                break;
              } else if (found) {
                content.append(child);
              }
            }

            this.$root.parentElement.append(content);
            this.contents.push(content);

            if (i > 0) {
              fastTab.remove();
            }
          });
        }

        this.activeTab = 0;
      }
    },
  }));
});